export const sortableFieldTypes = [
  'text',
  'textarea',
  'code',
  'json',
  'number',
  'email',
  'radio',
  'select',
  'date',
]
